// extracted by mini-css-extract-plugin
export var container = "_b3-0";
export var icon = "_b3-1";
export var text = "_b3-2";